import { render } from "./JMSort.vue?vue&type=template&id=665b5d41&ts=true&lang=pug"
import script from "./JMSort.vue?vue&type=script&lang=ts"
export * from "./JMSort.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__